// extracted by mini-css-extract-plugin
export default {"header":"_1F49bqzu","footer":"LwwE5W3s"};